export default __webpack_public_path__ + "static/media/image1.04e8d482.png";